import { render, staticRenderFns } from "./SocialDashboard.vue?vue&type=template&id=6bba40e3&"
import script from "./SocialDashboard.vue?vue&type=script&lang=js&"
export * from "./SocialDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SocialDashboard.vue?vue&type=style&index=0&id=6bba40e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports